import { render, staticRenderFns } from "./correctList.vue?vue&type=template&id=520126f2&scoped=true"
import script from "./correctList.vue?vue&type=script&lang=js"
export * from "./correctList.vue?vue&type=script&lang=js"
import style0 from "./correctList.vue?vue&type=style&index=0&id=520126f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520126f2",
  null
  
)

export default component.exports